import http from "@/axios";
import {Player} from "@/store/player/types";
import {LevelsInfo} from "@/store/creature/types";
import PlayerStore from "@/store/player";

export default class CreatureStore {

    public static addCreatureToSquad(desiredCreatureId: number, currentCreatureId: number ): Promise<Player>{
        let params = new URLSearchParams();
        params.append('desiredCreatureId', String(desiredCreatureId));
        params.append('currentCreatureId', String(currentCreatureId));
        return http.post('/api/creature/addToSquad', params)
            .then(r => r.data)
            .then(playerObj => {
                let player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static fetchLevelsInfo(creatureId: number): Promise<LevelsInfo> {
        return http.get('/api/creature/level/info?creatureId=' + String(creatureId))
            .then(r => r.data)
            .then(obj => {
                let res: LevelsInfo = Object.assign(new LevelsInfo(), obj);
                return res;
            });
    }

    public static fetchShortLevelsInfo(creatureId: number): Promise<LevelsInfo> {
        return http.get('/api/creature/level/short/info?creatureId=' + String(creatureId))
            .then(r => r.data)
            .then(obj => {
                let res: LevelsInfo = Object.assign(new LevelsInfo(), obj);
                return res;
            });
    }

    public static completeCreatureLevel(creatureId: number): Promise<Player> {
        const params = new URLSearchParams();
        params.append('creatureId', creatureId.toString())

        return http.post('/api/creature/level/complete', params)
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

}
